// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__wZ93r","bigColWidth":"Table_bigColWidth__i7mzd","biggerColWidth":"Table_biggerColWidth__7yvTH","row":"Table_row__2ULZV","col":"Table_col__1oprU"};